import { Box, Typography, Grid } from "@mui/material";
import { ReactNode } from "react";

interface QuestionnaryBoxProps {
  titlePrincipal: string;
  titleItem1: string;
  captionitem1: string;
  titleItem2?: string;
  captionitem2?: string;
  children?: ReactNode;
}

export const QuestionnaryBox = (props: QuestionnaryBoxProps) => {
  const { titlePrincipal, titleItem1, captionitem1, children, captionitem2, titleItem2 } = props;

  return (
    <Box sx={{ backgroundColor: "#FAFAFA", p: 2 }}>

      {children ? (
        children
      ) : (
        <Grid container spacing={1}>

          <Grid item xs={12} sm={12}>
            <Typography variant="h6">{titlePrincipal}</Typography>
          </Grid>

          <Grid item xs={6} sm={6}>
            <Typography variant="body2" color="textSecondary" sx={{ fontWeight: "bold" }}>
              {titleItem1}
            </Typography>
            <Typography variant="footer">{captionitem1}</Typography>
          </Grid>

          {!!titleItem2 &&
            <Grid item xs={6} sm={6}>
              <Typography variant="body2" color="textSecondary" sx={{ fontWeight: "bold" }}>
                {titleItem2}
              </Typography>
              <Typography variant="footer">{captionitem2}</Typography>
            </Grid>
          }
        </Grid>
      )}
    </Box>
  );
};